export default __webpack_public_path__ + "static/media/carousel-3.165e36ce.jpg";